module.exports = __webpack_public_path__ + "static/PODCASTS-e179ee4eb2fe409e4b634ea7099b8446.mp4";